/**
 * Spinner Component - Loading indicator
 */

import React from 'react';
import { Loader2 } from 'lucide-react';

const Spinner = ({
  size = 'md',
  className = '',
  variant = 'primary',
  label = 'Loading...',
  showLabel = false,
  ...props
}) => {
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12',
  };

  const variants = {
    primary: 'text-brand',
    white: 'text-white',
    muted: 'text-neutral-400',
    current: 'text-current',
  };

  return (
    <div className={`inline-flex flex-col items-center gap-2 ${className}`}>
      <Loader2
        className={`
          animate-spin
          ${sizes[size] || sizes.md}
          ${variants[variant] || variants.primary}
        `}
        {...props}
      />
      {showLabel && (
        <span className="text-xs text-muted">{label}</span>
      )}
    </div>
  );
};

// Full page spinner
export const FullPageSpinner = ({ message = 'Loading...' }) => (
  <div className="fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm z-50">
    <div className="text-center">
      <Spinner size="xl" />
      <p className="mt-4 text-sm text-muted">{message}</p>
    </div>
  </div>
);

// Inline spinner
export const InlineSpinner = (props) => (
  <Spinner {...props} />
);

Spinner.displayName = 'Spinner';

export default Spinner;